import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class Loader extends Component {

    render() {
        const { className, text } = this.props;
        const classes = classnames(
            "loader-container",
            className
        );

        return(
          <div className={ classes }>
              <div className="loader-content">
                 <div className="loader" />
                  <span>{ text }</span>
              </div>
          </div>
        );
    }

}

Loader.defaultProps = {
  text: 'Loading...'
};

Loader.propTypes = {
    text: PropTypes.string
};

export default Loader;


// WEBPACK FOOTER //
// ./src/components/loader.js